import { Model } from '@vuex-orm/core'

export default class Secret extends Model {
    static entity = 'secrets'

    static primaryKey = 'area_id'

    static fields() {
        return {
            area_id: this.attr(null),
            completed: this.attr(0),
            total: this.attr(0)
        }
    }
}